import { render, staticRenderFns } from "./DevelopmentLoginView.vue?vue&type=template&id=0cec93aa&scoped=true&"
import script from "./DevelopmentLoginView.vue?vue&type=script&lang=js&"
export * from "./DevelopmentLoginView.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentLoginView.vue?vue&type=style&index=0&id=0cec93aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec93aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCol,VContainer,VRow})
